<template>
    <select v-cloak v-model="selected" v-on:change="changeRoute" placeholder="Choose an option">
        <option disabled value="">Choose an option</option>
        <option v-for="(item, index) in departments" :value="item.dept_code.toLowerCase()" :key="index">
            {{ item.department_or_fund_name }}
        </option>
    </select>
</template>

<script>
    export default {
        name:'SelectDepartment',
        props: {
            'departments' : Array
        },
        data() { 
            return {
                selected:'',
            }   
        },
        methods: {
            changeRoute: function() {
                this.$router.push({path:'/' + this.selected });
            }
        } 
        
    }
</script>

<style scoped>
    select {
        float: right;
        display: block;
        margin-bottom:30px;
    }
</style>
